const LOCAL_STORAGE_KEY = 'cookiesAccepted'
const LOCAL_STORAGE_VAL = 'true'

class CookieBar {
    constructor(element) {
        if (!element) return

        this.element = element

        this._iniActions()
        this._checkLocalStorage()
    }

    _iniActions() {
        document.querySelector('.btn-agree').addEventListener('click', () => {
            this._setLocalStorage()
        })
    }

    _setLocalStorage() {
        localStorage.setItem(LOCAL_STORAGE_KEY, LOCAL_STORAGE_VAL)
        this._hideCookieBar()
    }

    _checkLocalStorage() {
        if (localStorage.getItem(LOCAL_STORAGE_KEY) !== LOCAL_STORAGE_VAL) {
            this._showCookieBar()
        }
    }

    _showCookieBar() {
        this.element.style.display = 'block'
    }

    _hideCookieBar() {
        this.element.style.display = 'none'
    }
}

export default CookieBar
